// extracted by mini-css-extract-plugin
export default {"corporate-only-lesson-definition-desc-wrapper":"corporate-only-lesson-definition-desc-wrapper_paCvL","button-group":"button-group_Sskfj","user-ids-box":"user-ids-box_sHt_6"};